import React from "react";
import { RouteComponentProps } from "react-router";
import { Box } from "@material-ui/core";

import {
  LoadingIndicator,
  B2BSpinner,
  HotelPriceBreakdown,
  IHotelPriceLineItem,
} from "halifax";
import { CallState } from "redmond";
import { PriceBreakdownConnectorProps } from "./container";

import "./styles.scss";

export interface IPriceBreakdownProps
  extends PriceBreakdownConnectorProps,
    RouteComponentProps {}

export const PriceBreakdown = ({
  pollPriceQuoteCallState,
  pricingLineItems,
  rewardsAndTotalLineItems,
}: IPriceBreakdownProps) => {
  const showLoadingIndicator =
    pollPriceQuoteCallState === CallState.InProcess ||
    pricingLineItems.length === 0;

  const pricingItems = pricingLineItems[0] as IHotelPriceLineItem[];

  return (
    <Box className="hotel-price-breakdown">
      {showLoadingIndicator ? (
        <LoadingIndicator
          className="hotel-price-breakdown-loading-indicator"
          indicatorSize="small"
          indicator={B2BSpinner}
          message="Fetching latest price"
        />
      ) : (
        <HotelPriceBreakdown
          className="pricing-line-items-breakdown"
          pricingItems={pricingItems}
          totalItems={pricingLineItems[1]}
          summaryItems={rewardsAndTotalLineItems}
        />
      )}
    </Box>
  );
};
